import {
  Col,
  Row,
  Modal,
  Divider,
  Form,
  Carousel,
  Spin,
  Select,
  message,
} from "../../../components/common/utils/antd-imports/AntdImports";
import "./SellerDashboard.css";
import { ReactComponent as RedirectIcon } from "../../../assests/Frame.svg";
import { ReactComponent as LeftArrowIcon } from "../../../assests/Vector 90.svg";
import { ReactComponent as RightArrowIcon } from "../../../assests/Vector 91.svg";
import { ReactComponent as AddIcon } from "../../../assests/add_icon_billboard.svg";
import { ReactComponent as BackArrow } from "../../../assests/back-arrow.svg";

import {
  XAxis,
  AreaChart,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Area,
} from "recharts";
import { useEffect, useState } from "react";
import AddBillBoard from "../../../components/common/bill-board/AddBillboard";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import {
  getSellerDashboardActivities,
  getSellerPaymentsInDashboard,
} from "../../../store/thunks/seller-thunks/SellerThunk";
import {
  formatToUSCurrency,
  truncatedNumber,
} from "../../../components/common/utils/Utils";
import BreadcrumbNav from "../../../components/common/bread-crumbs/BreadCrumb";
import { addBreadcrumb } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";

const SellerDashboard = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { user } = JSON?.parse(localStorage?.getItem("user") || "null") || {};
  const [isMonthly, setIsMonthly] = useState(false);
  const presentYear = new Date().getFullYear();
  const presentMonth = new Date().getMonth();
  const [year, setYear] = useState(presentYear);
  const [month, setMonth] = useState(presentMonth);
  const [isGuidelinesAccepted, setIsGuidelinesAccepted] = useState(false);
  const months = [
    { name: "January", value: 1 },
    { name: "February", value: 2 },
    { name: "March", value: 3 },
    { name: "April", value: 4 },
    { name: "May", value: 5 },
    { name: "June", value: 6 },
    { name: "July", value: 7 },
    { name: "August", value: 8 },
    { name: "September", value: 9 },
    { name: "October", value: 10 },
    { name: "November", value: 11 },
    { name: "December", value: 12 },
  ];
  const [openDialog, setOpenDialog] = useState(false);
  const { user: userProfile } = useSelector((state) => state.userprofile);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const { userGuidlineAcceptance } = useSelector((state) => state.userprofile);

  const [billBoardText, setBillboardText] = useState("");
  const [mobileOpenDialog, setMobileOpenDialog] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isPaymentsLoading, dashboardPaymentsData } = useSelector(
    (state) => state.sellerCampaigns,
  );
  const [chartFormattedData, setChartFormattedData] = useState([]);
  const { Option } = Select;
  const setTypeForRevenue = (isMonth) => {
    setIsMonthly(isMonth);
    dispatch(
      getSellerPaymentsInDashboard({
        type: isMonthly ? "monthly" : "yearly",
        selectedYear: year,
        selectedMonth: isMonthly ? presentMonth : "",
      }),
    );
  };
  const { isLoading, dashboardData } = useSelector(
    (state) => state.sellerCampaigns,
  );
  const goToSubPage = ({ title, path }) => {
    dispatch(addBreadcrumb({ title, path }));
  };
  const initialRecommendations = [
    {
      id: 1,
      text: "Consider offering a seasonal discount on ",
      highlight: "‘City Center Product’",
    },
    {
      id: 2,
      text: "Boost your online ads for ",
      highlight: "‘Downtown Plaza’",
    },
    {
      id: 3,
      text: "Increase engagement with offers on ",
      highlight: "‘Sunset Mall Displays’",
    },
    {
      id: 4,
      text: "Increase salary with package on ",
      highlight: "‘People tech group’",
    },
  ];

  const handleYear = (type) => {
    if (type == "decrement") setYear((prev) => prev - 1);
    else if (year === presentYear) return;
    else setYear((prev) => prev + 1);
    dispatch(
      getSellerPaymentsInDashboard({
        type: !isMonthly ? "monthly" : "yearly",
        selectedYear: type == "decrement" ? year - 1 : year + 1,
        selectedMonth: !isMonthly ? month : "",
      }),
    );
  };

  const handleMonth = (value) => {
    setMonth(value);
    dispatch(
      getSellerPaymentsInDashboard({
        type: !isMonthly ? "monthly" : "yearly",
        selectedYear: year,
        selectedMonth: value,
      }),
    );
  };

  const CustomTooltip = ({ active, payload, label, selectedYear }) => {
    if (active && payload && payload.length) {
      const value = payload[0]?.value;
      const displayValue =
        typeof value === "number" ? formatToUSCurrency(value) : "$0.00";

      let formattedDate = `${label ?? ""}`;

      return (
        <div className="seller-dashboard-custom-tooltip">
          <span className="seller-dashboard-custom-tooltip-text">
            {displayValue}
          </span>
          <span className="seller-dashboard-custom-tooltip-date">
            {formattedDate}
          </span>
        </div>
      );
    }
    return null;
  };
  const enhancedData = chartFormattedData?.map((d, index) => ({
    ...d,
    progress: index / (chartFormattedData?.length - 1),
  }));

  // Fetching data on component load
  useEffect(() => {
    dispatch(getSellerDashboardActivities());
    dispatch(
      getSellerPaymentsInDashboard({
        type: !isMonthly ? "monthly" : "yearly",
        selectedYear: year ? year : presentYear,
        selectedMonth: !isMonthly ? month : "",
      }),
    );
  }, []);

  // Populating Year/ Month data based on selected month and year in the graph
  useEffect(() => {
    if (!isPaymentsLoading && dashboardPaymentsData) {
      const { monthly_paid, weekly_paid } = dashboardPaymentsData;
      if (monthly_paid) {
        if (Object.keys(monthly_paid)?.length == 0) {
          let monthlyData = {
            monthly_paid: {
              Jan: 0,
              Feb: 0,
              Mar: 0,
              Apr: 0,
              May: 0,
              Jun: 0,
              Jul: 0,
              Aug: 0,
              Sep: 0,
              Oct: 0,
              Nov: 0,
              Dec: 0,
            },
          };
          const formatted = Object.entries(monthlyData).map(
            ([month, value]) => ({
              month,
              value,
            }),
          );
          setChartFormattedData(formatted);
        } else {
          const formatted = Object.entries(monthly_paid).map(
            ([month, value]) => ({
              month,
              value,
            }),
          );
          setChartFormattedData(formatted);
        }
      } else {
        let weeklyData = weekly_paid;
        if (!weeklyData || Object.keys(weeklyData).length === 0) {
          let weeklyData = {
            weekly_paid: {
              "Week 1": 0,
              "Week 2": 0,
              "Week 3": 0,
              "Week 4": 0,
              "Week 5": 0,
            },
          };
          const formatted = Object.entries(weeklyData).map(([week, value]) => ({
            week,
            value,
          }));
          setChartFormattedData(formatted);
        } else {
          setChartFormattedData(
            Object.entries(dashboardPaymentsData?.weekly_paid)?.map(
              ([week, value]) => ({
                week,
                value,
              }),
            ),
          );
        }
      }
    }
  }, [isPaymentsLoading, dashboardPaymentsData]);

  const handleAddProduct = () => {
    // as of now user directly adding the new product without any restrictions
    setOpenDialog(true);
    setIsGuidelinesAccepted(false);
    setBillboardText("Add New Product");
  };

  useEffect(() => {
    if (isMobile) {
      setOpenDialog(false);
    } else {
      setMobileOpenDialog(false);
    }
  }, [isMobile]);

  return (
    <>
      {
        <>
          {!mobileOpenDialog && (
            <div className="seller-dashboard-main-div common-container">
              <BreadcrumbNav />
              <Row style={{ marginBottom: "2rem" }}>
                <Col>
                  <p>
                    <span className="welcome-header welcome-header-css">
                      Welcome Back,{" "}
                    </span>
                    <span className="welcome-header welcome-username-css">
                      {user?.firstName} {user?.lastName}
                    </span>
                  </p>
                  <div>
                    <span style={{ fontFamily: "Roboto" }}>
                      Your advertising space, your rules. Manage products, track
                      revenue, and connect with buyers—all in one place!
                    </span>
                  </div>
                </Col>
              </Row>
              <Row
                className="seller-dashboard-carousel-row"
                style={{
                  flexFlow: isMobile ? "wrap" : "nowrap",
                }}
              >
                {isMobile && (
                  <Carousel
                    dots={true}
                    arrows
                    infinite={false}
                    className="billboard-carousel"
                  >
                    {[...Array(3)]?.map((_, index) => (
                      <Col
                        key={index}
                        className="seller-dashboard-carousel-col"
                      >
                        <div className="seller-dashboard-div-css seller-dashboard-carousel-div-css seller-dashboard-div-layout">
                          {index === 0 && (
                            <>
                              <p
                                className="seller-dashboard-child-div-header-css"
                                style={{
                                  color: "var(--Colors-Text-300, #D2042D)",
                                }}
                              >
                                Product Status
                              </p>
                              <Row className="sub-headers-div">
                                <Col>
                                  <span className="seller-dashboard-child-div-sub-header-css">
                                    Active Products
                                  </span>
                                  <p className="seller-dashboard-child-div-sub-header-value-css">
                                    {dashboardData?.active_products_count ?? 0}
                                  </p>
                                </Col>
                                <Col>
                                  <span className="seller-dashboard-child-div-sub-header-css">
                                    Pending Approvals
                                  </span>
                                  <p className="seller-dashboard-child-div-sub-header-value-css">
                                    {dashboardData?.pending_products_count ?? 0}
                                  </p>
                                </Col>
                              </Row>
                            </>
                          )}
                          {index === 1 && (
                            <>
                              <p
                                className="seller-dashboard-child-div-header-css"
                                style={{
                                  color: "var(--Colors-Text-300, #D2042D)",
                                }}
                              >
                                YOUR CAMPAIGNS
                              </p>
                              <Row className="sub-headers-div">
                                <Col>
                                  <span className="seller-dashboard-child-div-sub-header-css">
                                    Active Campaigns
                                  </span>
                                  <p className="seller-dashboard-child-div-sub-header-value-css">
                                    {dashboardData?.active_campaigns ?? 0}
                                  </p>
                                </Col>
                                <Col>
                                  <span className="seller-dashboard-child-div-sub-header-css">
                                    Pending Approval
                                  </span>
                                  <p className="seller-dashboard-child-div-sub-header-value-css">
                                    {dashboardData?.pending_approval_campaigns ??
                                      0}
                                  </p>
                                </Col>
                              </Row>
                            </>
                          )}
                          {index === 2 && (
                            <>
                              <p
                                className="seller-dashboard-child-div-header-css"
                                style={{
                                  color: "var(--Colors-Text-300, #D2042D)",
                                }}
                              >
                                REVENUE PERFORMANCE
                              </p>
                              <Row className="sub-headers-div">
                                <Col>
                                  <span className="seller-dashboard-child-div-sub-header-css">
                                    Total Revenue
                                  </span>
                                  <p className="seller-dashboard-child-div-sub-header-value-css">
                                    {formatToUSCurrency(
                                      Number(
                                        dashboardData?.total_paid ?? 0,
                                      )?.toFixed(2),
                                    )}{" "}
                                  </p>
                                </Col>
                                <Col>
                                  <span className="seller-dashboard-child-div-sub-header-css">
                                    Pending Payments
                                  </span>
                                  <p className="seller-dashboard-child-div-sub-header-value-css">
                                    {formatToUSCurrency(
                                      truncatedNumber(
                                        dashboardData?.pending_payments,
                                      ),
                                    )}
                                  </p>
                                </Col>
                              </Row>
                              <Col>
                                <span className="seller-dashboard-child-div-sub-header-css">
                                  Monthly Growth
                                </span>
                                <p className="seller-dashboard-child-div-sub-header-value-css seller-dashboard-child-div-sub-header-value-size-css">
                                  +12%
                                </p>
                              </Col>
                            </>
                          )}
                        </div>
                      </Col>
                    ))}
                  </Carousel>
                )}

                {!isMobile && (
                  <>
                    <Col style={{ width: "25%" }}>
                      <div className="seller-dashboard-div-css seller-dashboard-div-layout">
                        <p className="seller-dashboard-child-div-header-css">
                          PRODUCT STATUS
                        </p>
                        <Row className="sub-headers-div">
                          <Col>
                            <span className="seller-dashboard-child-div-sub-header-css">
                              Active Products
                            </span>
                            <p className="seller-dashboard-child-div-sub-header-value-css">
                              {dashboardData?.active_products_count ?? 0}
                            </p>
                          </Col>
                          <Col>
                            <span className="seller-dashboard-child-div-sub-header-css">
                              Pending Approvals
                            </span>
                            <p className="seller-dashboard-child-div-sub-header-value-css">
                              {dashboardData?.pending_products_count ?? 0}
                            </p>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                    <Col style={{ width: "25%" }}>
                      <div className="seller-dashboard-div-css seller-dashboard-div-layout">
                        <p className="seller-dashboard-child-div-header-css">
                          YOUR CAMPAIGNS
                        </p>
                        <Row className="sub-headers-div">
                          <Col>
                            <span className="seller-dashboard-child-div-sub-header-css">
                              Active Campaigns
                            </span>
                            <p className="seller-dashboard-child-div-sub-header-value-css">
                              {dashboardData?.active_campaigns ?? 0}
                            </p>
                          </Col>
                          <Col>
                            <span className="seller-dashboard-child-div-sub-header-css">
                              Pending Approvals
                            </span>
                            <p className="seller-dashboard-child-div-sub-header-value-css">
                              {dashboardData?.pending_approval_campaigns ?? 0}
                            </p>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                    <Col style={{ width: "25%" }}>
                      <div className="seller-dashboard-div-css seller-dashboard-div-layout">
                        <p className="seller-dashboard-child-div-header-css">
                          REVENUE PERFORMANCE
                        </p>
                        <Row className="sub-headers-div">
                          <Col>
                            <span className="seller-dashboard-child-div-sub-header-css">
                              Total Revenue
                            </span>
                            <p className="seller-dashboard-child-div-sub-header-value-css">
                              {formatToUSCurrency(
                                Number(dashboardData?.total_paid ?? 0)?.toFixed(
                                  2,
                                ),
                              )}
                            </p>
                          </Col>
                          <Col>
                            <span className="seller-dashboard-child-div-sub-header-css">
                              Pending Payments
                            </span>
                            <p
                              className="seller-dashboard-child-div-sub-header-value-css"
                              title={formatToUSCurrency(
                                Number(
                                  dashboardData?.pending_payments ?? 0,
                                )?.toFixed(2),
                              )}
                            >
                              {truncatedNumber(
                                formatToUSCurrency(
                                  Number(
                                    dashboardData?.pending_payments?.toFixed(
                                      2,
                                    ) ?? 0,
                                  ),
                                )?.toString(),
                              )}
                            </p>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </>
                )}
                {!isMobile && (
                  <Col
                    style={{ width: isMobile ? "100%" : "16.6%" }}
                    className="seller-dashboard-actions-div"
                  >
                    <Row
                      className="seller-dashboard-actions-child-div"
                      onClick={() => handleAddProduct()}
                    >
                      Add Product
                    </Row>
                    <Row
                      className="seller-dashboard-actions-child-div"
                      onClick={() => {
                        goToSubPage({
                          title: "My Products",
                          path: "/seller/myproducts",
                        });
                        navigate("/seller/myproducts");
                      }}
                    >
                      <span> My Products</span>{" "}
                      <RedirectIcon style={{ width: "18px" }} />
                    </Row>
                    <Row
                      className="seller-dashboard-actions-child-div"
                      onClick={() => {
                        goToSubPage({
                          title: "Campaigns",
                          path: "/seller/viewCampaigns?segment=insertion_order",
                        });

                        navigate(
                          "/seller/viewCampaigns?segment=insertion_order",
                        );
                      }}
                    >
                      <span>View Campaigns</span>{" "}
                      <RedirectIcon style={{ width: "18px" }} />
                    </Row>
                  </Col>
                )}
              </Row>
              {isMobile && (
                <Row
                  style={{ marginBottom: "1rem" }}
                  className="seller-dashboard-actions-child-div"
                  onClick={() => setMobileOpenDialog(true)}
                >
                  <AddIcon style={{ color: "#fff", width: "18px" }} /> Add
                  Product
                </Row>
              )}

              <Row className="seller-dashboard-row">
                <Col style={{ width: "100%" }}>
                  <div className="seller-dashboard-div-css seller-dashboard-div-layout">
                    <div
                      style={{
                        display: isMobile ? "block" : "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p className="seller-dashboard-child-div-header-css">
                        REVENUE PERFORMANCE
                      </p>
                      <div className="performance-div">
                        <div className="revenue-performance">
                          <div
                            className={
                              isMonthly
                                ? "revenue-performance-tab-1"
                                : "revenue-performance-tab-2"
                            }
                            onClick={() => setTypeForRevenue(false)}
                          >
                            Monthly
                          </div>
                          <div
                            className={
                              isMonthly
                                ? "revenue-performance-tab-2"
                                : "revenue-performance-tab-1"
                            }
                            onClick={() => setTypeForRevenue(true)}
                          >
                            Yearly
                          </div>
                        </div>
                        {!isMonthly && (
                          <div>
                            <Select
                              className="month-select"
                              defaultValue={month}
                              onChange={handleMonth}
                            >
                              {months?.map((month, index) => (
                                <Option
                                  key={index}
                                  value={month.value}
                                  disabled={
                                    month.value > presentMonth &&
                                    year === presentYear
                                      ? true
                                      : false
                                  }
                                >
                                  {month.name}
                                </Option>
                              ))}{" "}
                            </Select>
                          </div>
                        )}

                        <div
                          className={`revenue-performance-years-tab ${
                            !isMonthly && isMobile ? "mobile-year-tab" : ""
                          }`}
                        >
                          <RightArrowIcon
                            className="revenue-performance-icons"
                            onClick={() => handleYear("decrement")}
                          />
                          <span style={{ fontFamily: "Roboto" }}>{year}</span>
                          <LeftArrowIcon
                            className="revenue-performance-icons"
                            onClick={() => handleYear("increment")}
                          />
                        </div>
                      </div>
                    </div>

                    <div>
                      <ResponsiveContainer
                        width="100%"
                        height={200}
                        className="seller-dashboard-revenue-chart"
                      >
                        {isPaymentsLoading ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "flex-end",
                              marginTop: "5rem",
                            }}
                          >
                            <Spin size="small" />
                          </div>
                        ) : (
                          <AreaChart
                            width={500}
                            height={200}
                            data={enhancedData}
                            syncId="anyId"
                            margin={{
                              top: 10,
                              right: 30,
                              left: 0,
                              bottom: 0,
                            }}
                          >
                            <XAxis dataKey={!isMonthly ? "week" : "month"} />
                            <YAxis
                              tickFormatter={(tick) => `$${tick}`}
                              domain={[0, 20000]}
                            />
                            <Tooltip
                              content={<CustomTooltip selectedYear={year} />}
                            />
                            <Area
                              type="monotone"
                              dataKey="value"
                              stroke="#D2042D"
                              fill="rgba(210, 4, 45, 0.09)"
                              isAnimationActive={false}
                              activeDot={{
                                r: 5,
                                stroke: "red",
                                fill: "white",
                                strokeWidth: 2,
                              }}
                            />
                          </AreaChart>
                        )}
                      </ResponsiveContainer>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
          {isLoading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spin size="large" fullscreen />
            </div>
          )}

          {!mobileOpenDialog && (
            <Modal
              className="billboard-dialog"
              title={billBoardText}
              centered
              open={openDialog}
              maskClosable={false}
              destroyOnClose={true}
              onOk={() => setOpenDialog(false)}
              onCancel={() => {
                form.resetFields();
                setOpenDialog(false);
              }}
              footer={null}
              style={{ width: "90%" }}
              width={{
                xs: "90%",
                sm: "80%",
                md: "70%",
                lg: "60%",
                xl: "50%",
                xxl: "40%",
              }}
            >
              <Divider />
              <AddBillBoard
                upfrontAmount={userProfile?.upfront_amount}
                key={!mobileOpenDialog ? Date.now() : "closed"}
                form={form}
                isDashboardProduct={true}
                openDialog={openDialog}
                setOpenDialog={(value) => setOpenDialog(value)}
                setSelectedProduct={setSelectedProduct}
                setCurrentPage={setCurrentPage}
              />
            </Modal>
          )}
        </>
      }
      {mobileOpenDialog && (
        <>
          {isMobile && (
            <div className="seller-dashboard-back-arrow">
              <BackArrow
                onClick={() => {
                  form.resetFields();
                  setMobileOpenDialog(false);
                }}
              />
              <span className="campaign  my-campaign">Add New Product</span>
            </div>
          )}
          <AddBillBoard
            upfrontAmount={userProfile?.upfront_amount}
            key={mobileOpenDialog ? Date.now() : "closed"}
            form={form}
            mobileOpenDialog={mobileOpenDialog}
            setSelectedProduct={setSelectedProduct}
            setCurrentPage={setCurrentPage}
            setMobileOpenDialog={(value) => setMobileOpenDialog(value)}
          />
        </>
      )}
    </>
  );
};

export default SellerDashboard;
